/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	HttpClient
} from '@angular/common/http';
import {
	Inject,
	Injectable
} from '@angular/core';
import {
	IOperationTypeParameterDto
} from '@api/interfaces/operations/operation-type-parameter.dto.interface';
import {
	BaseEntityApiService
} from '@api/services/base/base-entity.api.service';
import {
	AppConstants
} from '@shared/constants/app.constants';
import {
	CacheService
} from '@shared/services/cache.service';

/**
 * A class representing the logic and services of the operation
 * type parameter controller.
 *
 * @export
 * @class OperationTypeParameterApiService
 * @extends {BaseEntityApiService<IOperationTypeParameterDto>}
 */
@Injectable()
export class OperationTypeParameterApiService
	extends BaseEntityApiService<IOperationTypeParameterDto>
{
	/**
	 * Creates an instance of an OperationTypeParameterApiService.
	 *
	 * @param {HttpClient} HttpClient
	 * The injected http client to use in the base api service.
	 * @param {CacheService} cache
	 * The injected cache service to use in the base api service.
	 * @memberof OperationTypeParameterApiService
	 */
	public constructor(
		@Inject(HttpClient) http: HttpClient,
		@Inject(CacheService) cache: CacheService)
	{
		super();
		this.httpClient = http;
		this.cacheService = cache;
		this.endpoint =
			AppConstants.apiControllers.operationTypeParameters;
	}
}
